export default __webpack_public_path__ + "static/media/item_6.82743a5e.png";